import type { ReactNode } from 'react';

export const symbol_payment_arrow_down: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M479.76-530Q438-530 409-559.24q-29-29.23-29-71Q380-672 409.24-701q29.23-29 71-29Q522-730 551-700.76q29 29.23 29 71Q580-588 550.76-559q-29.23 29-71 29ZM180-380q-24.75 0-42.37-17.63Q120-415.25 120-440v-380q0-24.75 17.63-42.38Q155.25-880 180-880h600q24.75 0 42.38 17.62Q840-844.75 840-820v380q0 24.75-17.62 42.37Q804.75-380 780-380H180Zm100-60h400q0-42 29-71t71-29v-180q-42 0-71-29t-29-71H280q0 42-29 71t-71 29v180q42 0 71 29t29 71Zm-100 0v-380 380Zm270 246-33-33q-9-9-21-9t-21 9q-9 9-9 21t8.91 20.91l84.23 84.23Q464-96 469.13-94q5.14 2 11 2Q486-92 491-94q5-2 9.86-6.86l84.23-84.23Q594-194 594-206t-9-21q-9-9-21-9t-21 9l-33 33v-96q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v96Z"
		/>
	</svg>
);
